import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/logo-sm.png")